import React from 'react';
import { Link } from 'react-router-dom';
import './PublicPages.css';

const Services = () => {
  const services = [
    {
      icon: '📁',
      title: 'Case Registration',
      description: 'Register new cases with automated case number generation. Support for Civil, Criminal, Family, and other case types.',
      features: ['Auto case number generation', 'Multiple case types', 'Court & judge assignment', 'Party management'],
    },
    {
      icon: '📅',
      title: 'Hearing Management',
      description: 'Schedule and manage court hearings efficiently with automated reminders and status tracking.',
      features: ['Hearing scheduling', 'Court & bench allocation', 'Judge assignment', 'Proceedings recording'],
    },
    {
      icon: '📄',
      title: 'Document Management',
      description: 'Secure document storage and management system with role-based access control and version tracking.',
      features: ['Document upload', 'Role-based access', 'Secure storage', 'Version control'],
    },
    {
      icon: '⚖️',
      title: 'Judgment & Orders',
      description: 'Digital judgment entry system with PDF order management and case closure tracking.',
      features: ['Judgment entry', 'Order upload', 'Case closure', 'Digital signatures'],
    },
    {
      icon: '📋',
      title: 'Cause List Generation',
      description: 'Automated daily cause list generation with court-wise and judge-wise views for public access.',
      features: ['Daily cause lists', 'Court-wise view', 'Judge-wise view', 'Public access'],
    },
    {
      icon: '🔍',
      title: 'Case Status Tracking',
      description: 'Public case status search system allowing users to track cases by multiple search criteria.',
      features: ['Case number search', 'Party name search', 'Advocate search', 'Real-time updates'],
    },
    {
      icon: '👨‍⚖️',
      title: 'Judge Management',
      description: 'Comprehensive judge profile management with court allocation and tenure tracking.',
      features: ['Judge profiles', 'Court allocation', 'Tenure tracking', 'Performance reports'],
    },
    {
      icon: '👨‍💼',
      title: 'Advocate Management',
      description: 'Advocate registration and case mapping system with specialization tracking.',
      features: ['Advocate registration', 'Bar enrollment', 'Case mapping', 'Specialization tracking'],
    },
    {
      icon: '📊',
      title: 'Reports & Analytics',
      description: 'Comprehensive reporting system with case statistics, judge performance, and disposal rates.',
      features: ['Case status reports', 'Judge performance', 'Advocate statistics', 'Analytics dashboard'],
    },
  ];

  return (
    <div className="services-page">
      <div className="page-header">
        <div className="container">
          <h1>Our Services</h1>
          <p>Comprehensive court management solutions for modern judiciary</p>
        </div>
      </div>

      <div className="container">
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>✓ {feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="services-cta">
          <h2>Ready to Get Started?</h2>
          <p>Access our services by logging into the system or contact us for more information</p>
          <div className="cta-buttons">
            <Link to="/login" className="btn-primary-large">
              Login to System
            </Link>
            <Link to="/contact" className="btn-secondary-large">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;

